import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../../Common/Constants";
import { muscleList, muscleInsert, muscleUpdate } from "../../../Redux/Actions";
import { types } from "../../../Redux/Actions/types";
import TextField from "../../Common/Fields/TextField";
import ButtonCustom from "../../Common/Fields/ButtonCustom";
import usePermissions from "../../Common/Functions/usePermissions";

const MuscleForm = () => {
  const dispatch = useDispatch();
  const { muscleSingle } = useSelector((state) => state.Muscle);
  // Permissions
  const addPermission = usePermissions(Constants.permission.BODY_PART_ADD);
  const editPermission = usePermissions(Constants.permission.BODY_PART_EDIT);

  // Initial values to Muscle form
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  // Validations for Muscle form
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill Muscle form
    if (muscleSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (muscleSingle[key]) {
          editValue[key] = muscleSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [muscleSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update muscleSingle API
        let submitFunc = muscleInsert(values);
        if (muscleSingle._id) {
          values.id = muscleSingle._id;
          submitFunc = muscleUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.MUSCLE_SINGLE, payload: "" });
            dispatch({ type: types.MUSCLE_FORM_MODEL, payload: "" });
          }
          dispatch(muscleList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="name"
              className="form-control"
              errors={touched?.name ? errors?.name : undefined}
              touched={touched?.name}
              label={Constants.name}
            />
          </div>
          {((addPermission && !muscleSingle?._id) ||
            (editPermission && muscleSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default MuscleForm;
